module.exports = __webpack_public_path__ + "img/MapPicsGrasslands.03777bb8.webp";